import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'

const WirecardActions = importer('Stores/Wirecard/Actions')
const { getWirecardInfo } = importer('APIs/wirecard', null)
const { tokens } = importer('Stores/Users/Select', null)

export default function * main ({ pdn, startDate, endDate }) {
  try {
    const _tokens = yield select(tokens)
    const { token_type, id_token } = _tokens
    const token = `${token_type} ${id_token}`
    yield put(WirecardActions.getWirecardInfoLoading())
    const res = yield getWirecardInfo(pdn, startDate, endDate, token)
    if (res && (res.status === 200 || res.status === 304) && res.data?.balance) {
      yield put(WirecardActions.getWirecardInfoSuccess(res))
    } else {
      yield put(
        WirecardActions.getWirecardInfoFailure(
          new Error('Your BioLife Prepaid Mastercard balance and transaction history is temporarily unavailable.')
        )
      )
    }
  } catch (error) {
    yield put(
      WirecardActions.getWirecardInfoFailure(
        new Error('Your BioLife Prepaid Mastercard balance and transaction history is temporarily unavailable.')
      )
    )
  }
}
